import { createApp } from "vue";
import { Quasar, Notify, Dialog, Loading } from "quasar";
//import "./style.css";
import App from "./App.vue";

// Import icon libraries
import "@quasar/extras/roboto-font/roboto-font.css";
import "@quasar/extras/material-icons/material-icons.css";

import iconSet from "quasar/icon-set/fontawesome-v6-pro";
import "@fortawesome/fontawesome-pro/css/fontawesome.min.css";
import "@fortawesome/fontawesome-pro/css/light.min.css";

// Import Quasar css
import "quasar/src/css/index.sass";

import router from "@/router";
import store, { key } from "@/store";
import SecurityUseCase from "./usecases/SecurityUseCase";
import { processResponse } from "./shared/helperFunctions";

const app = createApp(App);

app.use(Quasar, {
  plugins: { Notify, Dialog, Loading },
  iconSet,
  config: { notify: {} },
});

app.use(store, key);

async function bootstrap() {
  await setup();
  app.use(router);
  app.mount("#app");
}

bootstrap();

async function setup() {
  const securityUseCase = new SecurityUseCase();

  try {
    if ((await securityUseCase.doesTokenExist()) && !store.state.user) {
      const result = await securityUseCase.updateToken();
      processResponse(result, (_) => {});
    }

    await store.dispatch("actionLoadSystemSetting");
    await store.dispatch("actionLoadReferenceData");
  } catch (error) {
    // if (error instanceof Error) $q.notify(showErrorNotification(error.message));
  }
}
